import { render, staticRenderFns } from "./newProductAdd.vue?vue&type=template&id=a1dff59a&scoped=true&"
import script from "./newProductAdd.vue?vue&type=script&lang=js&"
export * from "./newProductAdd.vue?vue&type=script&lang=js&"
import style0 from "./newProductAdd.vue?vue&type=style&index=0&id=a1dff59a&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1dff59a",
  null
  
)

export default component.exports